const OAUTH_BASE = "https://accounts.google.com/o/oauth2/v2/auth";

function buildOAuthUrl(params: { state?: string }): string {
  const searchParams = new URLSearchParams({
    client_id: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
    redirect_uri: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URI,
    scope: import.meta.env.VITE_GOOGLE_OAUTH_SCOPES,
    response_type: "code",
    access_type: "offline",
    prompt: "consent"
  });

  if (params.state) {
    searchParams.set("state", params.state);
  }

  return `${OAUTH_BASE}?${searchParams.toString()}`;
}

/**
 * Redirect the user to Google OAuth for sign-in.
 * After consent, Google redirects back with ?code=...&state=...
 */
export function startGoogleSignIn(): void {
  const url = buildOAuthUrl({
    state: "signin"
  });
  window.location.href = url;
}

/**
 * Parse the OAuth callback URL for the authorization code and state.
 */
export function parseOAuthCallback(search: string): { code: string | null; state: string | null } {
  const params = new URLSearchParams(search);
  return {
    code: params.get("code"),
    state: params.get("state")
  };
}
